import { render } from "./BlogDetailView.vue?vue&type=template&id=cc8e51b8&scoped=true"
import script from "./BlogDetailView.vue?vue&type=script&lang=js"
export * from "./BlogDetailView.vue?vue&type=script&lang=js"

import "./BlogDetailView.vue?vue&type=style&index=0&id=cc8e51b8&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc8e51b8"]])

export default __exports__